/* eslint-disable */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, CircularProgress, Grid, Paper, Dialog, DialogContent } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import RHFSelect from 'src/components/elements/Select/RHFSelect';
import { Loader, StatusDropdown } from 'src/components';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import { getOptions } from '../../../CandidateInfo/utils';
import {
  Job,
  JobStatus,
  JobCardType,
  Activity,
} from '../../types';
import Activities from '../Activities';
import { CandidateDetails } from 'src/pages/CandidateInfo/types';
import Comments from 'src/components/StatusDropdown/Comments';
import API from "../../../../network";
import { confirmWrapper } from 'src/components/Dialog';

interface JobUpdateFormProps {
  job: Job,
  loading: boolean,
  updateJobStatus: (requestData: any) => void,
  jobStatuses: JobStatus[],
  jobHistory: Activity[],
  profileInfo: CandidateDetails | undefined;
  getCandidateJobHistory: (jobId: number, expanded: boolean) => Promise<void>,
  updateCandidateComments: (data: any) => Promise<void>,
}

function JobUpdateForm(props: JobUpdateFormProps) {
  const {
    job,
    loading,
    jobStatuses,
    jobHistory,
    profileInfo,
    updateJobStatus,
    getCandidateJobHistory,
    updateCandidateComments,
  } = props;

  const getFullName = (profileInfo?: CandidateDetails) => {
    if (!profileInfo) return ''; // Handle the case where profileInfo is undefined
    const { firstName, middleName, lastName } = profileInfo;
    return [firstName, middleName, lastName].filter(Boolean).join(' ');
  };
  
  const fullName = getFullName(profileInfo);

  const validationSchema = yup.object().shape({
    status: yup.string().required('Select Status'),
    comment: yup.string().required('Comment is mandatory'),
  });

  const methods = useForm<JobCardType>({
    defaultValues: {
      jobOrderId: 0,
      jobId: '',
      jobTitle: '',
      clientId: 0,
      clientName: '',
      organizationId: 0,
      updatedDate: 0,
      relevanceScore: 0,
      status: '',
      reminder: false,
      date: '',
      time: '',
      comment: '',
    },

    resolver: useYupValidationResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
  } = methods;

  const [openPopUpDialog, setOpenPopUpDialog] = useState(false);

  useEffect(() => {
    reset({
      jobOrderId: job?.jobOrderId,
      jobId: job?.jobId,
      jobTitle: job?.jobTitle,
      clientId: job?.clientId,
      clientName: job?.clientName,
      organizationId: job?.organizationId,
      updatedDate: job?.updatedDate,
      relevanceScore: job?.relevanceScore,
    });
  }, [job]);

  const handleClickAddComment = () => {
    setOpenPopUpDialog(true);
  }

  const handleCloseComments = () => {
    setOpenPopUpDialog(false);
  }

  const handleUpdateComments = async(data : any) => {
    const reqObj = {
      comments: data?.comments,
      candidateId: profileInfo?.candidateId,
      jobOrderId: job?.jobOrderId,
    }
    await updateCandidateComments(reqObj);
    setOpenPopUpDialog(false);
  }

  const handleSuccess = () => {
    getCandidateJobHistory(Number(job.jobOrderId),true)
  }

  const submitHandler = (data: JobCardType) => {
    const requestObj = {
      organizationId: data.organizationId,
      jobOrderId: data.jobOrderId,
      jobId: data.jobId,
      candidateStatus: data.status,
      clientName: data.clientName,
      recruiterId: data.clientId,
      addReminder: data.reminder,
      reminderDate: moment(data.date).format("DD/MM/YYYY"),
      reminderTime: moment(data.time).format("hh:mm a"),
      comments: data.comment,
      timeZoneId: null,
      primaryRole: "",
      userId: ''
    };
    updateJobStatus(requestObj);
  };

  return (
    <div className='flex flex-col justify-center'>
      {/* <Paper id="job-form" className="p-4 rounded-md text-left flex w-[95%] self-center" elevation={0}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitHandler)}>
            <div className="mb-4 text-lg underline text-secondary">Update Status:</div>
            <Grid container spacing={3} mb={4} pl={3}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <div className="h-full flex items-end">
                  <RHFSelect
                    control={methods.control}
                    name="status"
                    label="Status"
                    options={getOptions(jobStatuses)}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <RHFDatePicker
                  control={methods.control}
                  name='date'
                  label='Date'
                  minDate={moment(new Date())}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <RHFTimePicker
                  control={methods.control}
                  name='time'
                  label='Time'
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <RHFCheckbox
                  control={methods.control}
                  name="reminder"
                  label="Reminder"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={8}>
                <RHFTextArea control={methods.control} name="comment" label="Comment" rows={3}/>
              </Grid>    
            </Grid>
            <Grid display="flex" gap={1}>
              <Button
                variant="contained"
                size="large"
                type="submit"
              >
                Update
              </Button>
            </Grid>
          </form>
        </FormProvider>
      </Paper> */}
      <Paper id="job-form" className="p-4 mt-2 border-t-2 border-gray-100 rounded-md text-left flex w-[95%] self-center" elevation={0}>
      {loading ? (
          <div className="absolute bottom-[0vh] left-[34vw]">
            <Loader />
          </div>
        ) : (
          <div className='flex flex-col gap-2 w-full'>
          {
            profileInfo &&
            <div className='w-full flex justify-between items-end'>
              <div className='w-[400px]'>
                <div className='font-semibold mb-1 text-secondary'>Update Job Status:</div>
                <StatusDropdown
                  jobOrderId={Number(job.jobOrderId)}
                  candidateId={Number(profileInfo?.candidateId)}
                  candidateStatus={""}
                  emailIds={[profileInfo?.emailAddress]}
                  candidateName={fullName}
                  resumeData={{ ...profileInfo }}
                  onSuccess={handleSuccess}
                />
              </div>
              <Button variant='contained' onClick={handleClickAddComment}>Add Comment</Button>
            </div>
          }
          <Activities activities={jobHistory} />
          <Dialog
            open={openPopUpDialog}
            maxWidth="md"
          >
            <DialogContent>
              <Comments
                onCancel={handleCloseComments}
                onSubmit={handleUpdateComments}
                title='ADD COMMENT'
              />
            </DialogContent>
          </Dialog>
          </div>
        )} 
      </Paper>
    </div>
  );
}

export default JobUpdateForm;
